var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    fill: "#ff13dc",
    opacity: 0,
    width: 18,
    height: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10,8.043V3.5A.5.5,0,0,0,9.5,3h-1a.5.5,0,0,0-.5.5V8.793a.5.5,0,0,0,.1465.3535L10.95,11.95a.5.5,0,0,0,.70711.00039L11.6575,11.95l.6675-.6675a.5.5,0,0,0,.00039-.70711L12.325,10.575,10.1465,8.3965A.5.5,0,0,1,10,8.043Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.2425,3.45a7.08135,7.08135,0,0,1,1.313,1.3l.8715-.5a8.08636,8.08636,0,0,0-1.6825-1.668Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.9465,8.1a7.98218,7.98218,0,0,0-.6135-2.2945l-.871.503A6.98813,6.98813,0,0,1,15.9355,8.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.188,1.6785A7.993,7.993,0,0,0,9.9,1.0555V2.067a7.05663,7.05663,0,0,1,1.786.481Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.936,9.9A6.997,6.997,0,1,1,8.1,2.064V1.0535A8,8,0,1,0,16.946,9.9Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pending.c7c8aaa1c0a90d12156263b8d5fa7d88.svg";